import { Component, HostListener } from '@angular/core';
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { BehaviorSubject, interval, Observable } from 'rxjs';
import { debounce } from 'rxjs/operators';
import { DirtyFormRegistrationService } from './core/services/dirty-form-registration.service';
import { LocalizationService } from './core/services/localization.service';
import { ToolbarCustomisationService } from './core/services/toolbar-customisation-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  loadingSubject: BehaviorSubject<boolean>;

  loading$: Observable<boolean>;

  theme?: string;

  constructor(
    router: Router,
    private dirtyFormRegistrationService: DirtyFormRegistrationService,
    private toolbarCustomisationService: ToolbarCustomisationService,
    // Services that need to be instantiated on start
    // DON'T DELETE THEM!
    // Event though they are may not be in use by another service or component
    // they are crucial for application functioning!
    private localizationService: LocalizationService,
  ) {
    this.loadingSubject = new BehaviorSubject<boolean>(false);
    // Don't show preloader immediately
    // Only when it takes too long
    // Otherwise it will collide with some animations
    this.loading$ = this.loadingSubject.asObservable().pipe(
      debounce((value) => (value ? interval(300) : interval(0))),
    );

    this.toolbarCustomisationService.toolbarCustomisations$.subscribe((customisation) => {
      this.theme = customisation.theme;
    });
    router.events.subscribe(
      (event) => {
        if (event instanceof RouteConfigLoadStart) {
          this.loadingSubject.next(true);
        } else if (event instanceof RouteConfigLoadEnd) {
          this.loadingSubject.next(false);
        }
      },
    );
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadHandler(event: Event) {
    if (this.dirtyFormRegistrationService.isDirty()) {
      // Cancel the event
      event.preventDefault();
      // Chrome requires returnValue to be set
      event.returnValue = true;
    }
  }
}
